import './index.scss';

import React from 'react'
import Link from 'gatsby-link'

import FullImg from '../../components/full-img';

class PersonCard extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      hoverImg: {},
      hoverBg: {},
      expanded: false,
      expandWrapper: {},
      expandBg: {},
      expandImg: {}
    }
  }

  mouseOver = () => {
    if(this.state.expanded) return;
    this.setState({
      hoverImg: { transform: 'translate(25px, 10px)'},
      hoverBg: { transform: 'translate(10px, -10px)'}
    });
  }

  mouseOut = () => {
    if(this.state.expanded) return;
    this.setState({
      hoverImg: {},
      hoverBg: {}
    });
  }

  click = () => {
    if(!this.state.expanded){
      this.props.switchPerson(this.props.src);
      return this.setState({
        expandWrapper: {
          width: '100%',
          height: '325px',
          zIndex: 1
        },
        expandImg: {
          transform: 'translate(25px,45px)'
        },
        expandBg: {
          width: '100%',
          height: '100%',
          transform: 'translate(0,-50px)',
        },
        hoverImg: {},
        hoverBg: {},
        expanded: true
      })
    }

    this.props.switchPerson(false);
    this.setState({
      expandWrapper: {},
      expandImg: {},
      expandBg: {},
      expanded: false
    })
  }

  render(){
    let { src, style, name, tag, attrs } = this.props;
    return (
      <div className={`person-card ${this.state.expanded ? 'expanded' : ''}`} style={{
        ...style,
        top: 0,
        //left: 0,
        //transform: 'translate(0,0)',
        transition: 'all ease 0.35s',
        width: '240px',
        height: '360px',
        cursor: 'pointer',
        zIndex: 0,
        ...this.state.expandWrapper
      }}
      onClick={this.click}
      onMouseOver={this.mouseOver}
      onMouseOut={this.mouseOut}
      >
        <div style={{
          width: '240px',
          height: '360px',
          transform: 'translate(0,0)',
          background: '#F9A781',
          position: 'absolute',
          transition: 'all ease 0.35s',
          overflow: 'hidden',
          left: 0,
          bottom: 0,
          ...this.state.hoverBg,
          ...this.state.expandBg
        }}>
          <div className="person-card__text" style={{
            position: 'absolute',
            width: 'calc(100% - 275px)',
            left: '275px',
            transition: 'opacity 0.35s ease',
            visibility: this.state.expanded ? 'visible' : 'hidden',
            opacity: this.state.expanded ? 1 : 0,
            transitionDelay: '0.4s'
          }}>
            <div className='row'>
              <div className='col-lg-5 person-card__name' style={{ paddingLeft: '50px', position: 'relative', height: '325px' }}>
              <div style={{ position: 'absolute', top: '50%', transform: 'translateY(-50%)'}}>
                  <h2 style={{
                    color: '#fff',
                    letterSpacing: '0.075em',
                    fontSize: '36px',
                    fontFamily: 'Futura',
                    marginBottom: '15px'
                  }}>{name}</h2>
                  <p style={{
                    color: '#fff',
                    fontFamily: 'Futura',
                    fontWeight: 200,
                    marginBottom: 0
                  }}>{tag}</p>
                  <p style={{
                    color: '#fff',
                    fontFamily: 'Futura',
                    fontWeight: 200,
                    fontSize: '11px',
                    margin: 0
                  }}>
                  (she/her/hers)
                  </p>
                </div>
              </div>
              <div className='col-lg-7 person-card__superpowers' style={{ background: 'rgba(75,75,75,0.15)', paddingTop: '35px', height: '325px', position: 'relative' }}>
                <div className="person-card__superpowers__text">
                  <div style={{ marginBottom: '10px' }}>
                    <img src='/static/images/icons/lightning.svg' style={{ width: '15px', height: 'auto', display: 'inline-block', verticalAlign: 'middle' }} />
                    <h3 style={{ color: 'white', fontFamily: 'Futura', fontSize: '18px', fontWeight: 200, letterSpacing: '0.05em', marginLeft: '10px', display: 'inline-block', verticalAlign: 'middle'}}>
                      Super powers include:
                    </h3>
                  </div>
                {attrs.map((a,i)=>(
                  <div key={`attr-${i}`} className="person-card__attr" style={{
                    display: 'inline-block',
                    width: '50%',
                    height: '75px',
                    verticalAlign: 'top',
                    marginBottom: '35px',
                    paddingLeft: '10px',
                    paddingRight: '15px'
                  }}>
                    <h3 style={{
                      color: '#fff',
                      position: 'relative',
                      fontFamily: 'Futura',
                      fontSize: '12px',
                      letterSpacing: '0.1em',
                      margin: 0,
                      marginLeft: '15px',
                      marginBottom: '10px',
                      lineHeight: '1.25em',
                      textTransform: 'uppercase'
                    }}><span style={{ position: 'absolute', left: '-15px'}}>•</span>
                      {a.title}
                    </h3>
                    <p style={{
                      color: '#fff',
                      fontFamily: 'Futura',
                      marginLeft: '15px',
                      fontWeight: 200,
                      lineHeight: '1.3em',
                      fontSize: '14px'
                    }}>{a.desc}</p>
                  </div>
                ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="person-card__img" style={{
          width: '240px',
          height: '360px',
          overflow: 'hidden',
          position: 'absolute',
          transform: 'translate(50px,0)',
          transition: 'all ease 0.2s',
          bottom: '35px',
          ...this.state.hoverImg,
          ...this.state.expandImg
        }}>
          <img src={src} style={{
            height: '100%',
            width: 'auto',
            maxWidth: 'none',
            margin: 0
          }}/>
        </div>
      </div>
    );
  }
}

const About = () => (
  <div id="services-about" style={{
    padding: '0 0 90px 0',
    position: 'relative',
  }}>
    <div style={{
      width: '100%',
      maxWidth: '800px',
      padding: '0 10px',
      margin: '0px auto'
    }}>
      <h1 style={{
        marginBottom: '50px',
      }}><span><span>About Nicole</span></span></h1>
      <div style={{
        fontFamily: 'Futura',
        fontWeight: 200,
        lineHeight: '35px',
        fontSize: '24px',
        color: '#7f7f7f'
      }}>
        <p>Nicole Newman is a writer, passionate advocate and one of the co-founders of Two Brown Girls Consulting Cooperative.</p>
        <p>Nicole learned how to organize from her aunt and grandparents who at an early age exposed her to community action by those most impacted coming together for collective action. She was taught by her mother to ask as many questions as satisfied her curiosity. She is a graduate of Trinity University Washington DC with a degree in political science and is currently working on her Masters in Organizational Development from American University. She is an Americorps Vista Alum and has spent her professional career providing direct services to women experiencing homelessness, volunteer management and later on building coalitions and doing education and housing advocacy and organizing.</p>
        <p>With the co-founding of Two Brown Girls, Nicole wants to help create more equitable people focused organizations via training and conversation around racial equity and inclusion; community organizing and client engagement; advocacy; strategic growth and planning and navigating change and conflict.</p>
        <p>In addition to Two Brown Girls, Nicole does coaching and youth development work. She likes traveling (mostly with Aja) and sunflowers, unicorns, the enneagram and being in nature. Nicole is a dreamer at heart and you can often catch her mediating and sitting in silence.</p>
      </div>
      <h1 style={{
        marginBottom: '50px',
        marginTop: '50px'
      }}>
      <span><span>About Aja</span></span>
      </h1>
      <div style={{
        fontFamily: 'Futura',
        fontWeight: 200,
        lineHeight: '35px',
        fontSize: '24px',
        color: '#7f7f7f'
      }}>
        <p>Aja Taylor is a community organizer, master facilitator and one of the co-founders of Two Brown Girls Consulting Cooperative.</p>
        <p>She comes to this work as a young Black woman raised by socially conscious parents who always pushed their children to not just examine, but also challenge oppressive systems. Aja has been organizing since 14, where she organized young people and adult allies around the deplorable conditions at Oak Hill Juvenile Detention Facility in DC. Since then, her professional work has been with countless community organizations, coalitions and nonprofits to not just mobilize impacted people around critical public policies, but to intentionally develop the leadership infrastructure in ways that allow said communities to continue to put pressure on systems and challenge the status quo in ways that build their collective power.</p>
        <p>With Two Brown Girls Consulting Cooperative, Aja is excited to use the knowledge, skills and expertise she has gained as a grassroots organizer and mobilizer to help nonprofit, mission-driven and movement organizations deepen their relationship to their base and their work, create effective strategies to move their work forward, and also to build the capacity of organizations seeking to be be actively anti-racist&mdash;working with communities in ways that honor their salient knowledge and build their collective power.</p>
        <p>In addition to co-leading Two Brown Girls Consulting Cooperative, Aja also does political education workshops, community organizing curriculum development, and keynotes. She enjoys traveling anywhere with sand and blue water, and cooks the best seafood gumbo this side of the Mississippi.</p>
        <Link to="/services" className="button" style={{ marginTop: '50px', display: 'inline-block'}}>Our Services</Link>
      </div>
    </div>
  </div>
)


class AboutPage extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      active: false
    };
  }
  switchPerson = (img) => {
    this.setState({ active: img });
  }

  render(){
    let { active } = this.state;
    return (
      <div>
        <div className="container" style={{ marginTop: '90px', maxWidth: '740px', textAlign: 'center' }}>
          <h1 style={{ marginBottom: '50px' }}><span><span>Meet Aja &</span></span><span><span>&nbsp;Nicole</span></span></h1>
        </div>
        <div className='container person-cards' style={{ position: 'relative', height: '360px', margin: '50px auto 175px auto' }}>
          <PersonCard src='/static/images/nicole-headshot-2.min.jpg' switchPerson={this.switchPerson}
            name='Nicole Newman'
            tag='co&nbsp;-&nbsp;conspirator | facilitator'
            attrs={[
              { title: 'Ideation', desc: 'quickly able to brainstorm and develop ideas' },
              { title: 'Moving through Conflict', desc: 'comfort with and ability to lead through conflict' },
              { title: 'Intuition', desc: 'strong intuition and ability to read situations' },
              { title: 'Coaching', desc: 'experienced facilitator and coach' }
            ]}
            style={{
              opacity: active == '/static/images/nicole-headshot-2.min.jpg' || active===false ? 1 : 0
            }}/>
          <PersonCard src='/static/images/aja-headshot-2.min.jpg' switchPerson={this.switchPerson}
            name='Aja Taylor'
            tag='co&nbsp;-&nbsp;conspirator | facilitator'
            attrs={[
              { title: 'Big Picture Thinker', desc: 'long term invisioning and implementation wizard' },
              { title: 'Cutting to the Chase', desc: 'helping groups cut through the noise and have the right conversations' },
              { title: 'Synthesis', desc: 'distilling long discussions into salient points and themes (code name: the sensei of summary)' },
              { title: 'Reflection', desc: 'asking questions that encourage critical reflection and truth telling (even when it’s hard)' }
            ]}
            style={{
              opacity: active == '/static/images/aja-headshot-2.min.jpg' || active===false ? 1 : 0
            }}/>
        </div>
        <FullImg>
          <div className='col-8' style={{ height: '500px', overflow: 'hidden' }}>
            <img src='/static/images/meeting-laughing.jpg' style={{ width: 'auto', height: '100%', display: 'block' }}/>
          </div>
          <div className='col-4' style={{ height: '500px', overflow: 'hidden' }}>
            <img src='/static/images/nicole-explains.jpg' style={{ width: 'auto', marginBottom: '15px', height: '242.5px', display: 'block' }}/>
            <img src='/static/images/aja-explains.jpg' style={{ width: 'auto', margin: 0, height: '242.5px', display: 'block' }}/>
          </div>
        </FullImg>
        <About />
      </div>
    )
  }
}

export default AboutPage;



// WEBPACK FOOTER //
// ./src/pages/about/index.js